import { render, staticRenderFns } from "./hibah_masuk_form.vue?vue&type=template&id=66278366&"
import script from "./hibah_masuk_form.vue?vue&type=script&lang=js&"
export * from "./hibah_masuk_form.vue?vue&type=script&lang=js&"
import style0 from "./hibah_masuk_form.vue?vue&type=style&index=0&id=66278366&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports